/**
 * @generated SignedSource<<1535a8a05669a832da737501c4ede44a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksPremiumNativeAdConfigQuery$data = {
  readonly advertConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "hooksPremiumNativeAdConfigQuery";
};
export type hooksPremiumNativeAdConfigQuery$key = {
  readonly " $data"?: hooksPremiumNativeAdConfigQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksPremiumNativeAdConfigQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksPremiumNativeAdConfigQuery",
  "selections": [
    {
      "alias": "advertConfig",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "scmp_pwa_advert_campaign"
          }
        }
      ],
      "concreteType": "AppConfigs",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "json",
          "storageKey": null
        }
      ],
      "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_advert_campaign\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "44365780629c8bd5dc09d280810c0f37";

export default node;
